import { GetLink } from "./FrontendHelpers";
import axios from "axios";

// Create the Axios instance
const api = axios.create({
  baseURL: GetLink(),
});

// Add the request interceptor
api.interceptors.request.use((config) => {
  let requiresToken = true;
  let token;

  if (
    config.url.includes("/users/login") ||
    config.url.includes("/users/register") ||
    config.url.includes("/users/resendRegisterEmail") ||
    config.url.includes("/verify") ||
    config.url.includes("/users/sendPasswordResetEmail") ||
    config.url.includes("/auth/google")
  ) {
    requiresToken = false;
  }

  if (requiresToken) {
    token = localStorage.getItem("token");
    config.headers.Authorization = token;
  }

  if (requiresToken && !token) {
    console.error("No token found in localStorage!");
    const obj = {
      response: { status: 401, data: { error: "No token" } },
    };
    throw obj;
  }

  if (!(config.data instanceof FormData)) {
    config.headers["Content-Type"] = "application/json";
  }
  return config;
});

export default api;
